import React from "react";
import styles from "./style.m.css";
import Icon from "../../atoms/icon";

const VikatanPlusSpecialHeader = () => {
  return (
    <div className={styles["plus-header"]}>
      <div className="container">
        <div className={styles["vikatan-plus-logo-red"]}>
          <a href="/vikatan-plus-special" className={styles["vikatan-plus"]}>
            <Icon type="v-plus-logo" className={styles["vikatan-plus-icon"]} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default VikatanPlusSpecialHeader;
